import React, { useState } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { faqs } from '../../data/faq';
export function FAQ() {
  const [openIndexes, setOpenIndexes] = useState<Set<number>>(new Set([0]));
  const toggle = (i: number) => {
    setOpenIndexes(prev => {
      const next = new Set(prev);
      if (next.has(i)) {
        next.delete(i);
      } else {
        next.add(i);
      }
      return next;
    });
  };
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-39" data-mp="3rr4j9dk0li0y">
      <div className="mx-auto max-w-5xl px-6 sm:px-8" data-id="element-40" data-mp="3d3jelf7hraqx">
        <div className="text-center" data-id="element-41" data-mp="3d0x9rnbzj9ce">
          <SectionTag icon="❓" data-id="element-42" data-mp="3i1kx9z10981v">Resolvemos tus dudas</SectionTag>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-43" data-mp="9m9pvhefq5a5">
          {faqs.map((faq, i) => {
          const isOpen = openIndexes.has(i);
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-gris-claro bg-white" data-id="element-44" data-mp="eeavwll0ezrq" data-mpi={i}>
                <button onClick={() => toggle(i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-azul" aria-expanded={isOpen} data-id="element-45" data-mp="20r01r8hm6q0k">
                  <span className="font-heading text-base font-semibold text-marino" data-id="element-46" data-mp="25o8fmwvqc7w0">{faq.q}</span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-naranja transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-47" data-mp="2jfn59mk577c1" />
                </button>
                <AnimatePresence initial={false} data-id="element-48" data-mp="2ohcgp3ba1n0n">
                  {isOpen && <m.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-49" data-mp="z0l45p7tkvk6">
                      <div className="mx-5 mb-4 rounded-lg border-l-[3px] border-azul bg-azul-light p-4" data-id="element-50" data-mp="1nr8xr5d3vg8m">
                        <p className="text-[15px] leading-relaxed text-gris-texto" data-id="element-51" data-mp="1sq2c1007vb9u">{faq.a}</p>
                      </div>
                    </m.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}